"use strict";
/* !!! This component is deprecated. Please do not use for new code  !!! */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var Icon_1 = require("../Icon");
var Menu_module_scss_1 = __importDefault(require("./Menu.module.scss"));
/**
 * @deprecated MenuItem is deprecated. Please use draft-menu instead (it has its own menu item component).
 */
var MenuItem = function (props) {
    var _a;
    var icon = props.icon, hoverIcon = props.hoverIcon, children = props.children, action = props.action, active = props.active, destructive = props.destructive, automationId = props.automationId;
    var isLink = typeof action === "string";
    var label = (React.createElement("span", { className: Menu_module_scss_1["default"].menuItem__Label },
        children,
        isLink && "…"));
    var iconNode = icon && (React.createElement("span", { className: Menu_module_scss_1["default"].menuItem__Icon },
        React.createElement(Icon_1.Icon, { icon: icon, role: "presentation" })));
    var className = (0, classnames_1["default"])((_a = {},
        _a[Menu_module_scss_1["default"].menuItem] = true,
        _a[Menu_module_scss_1["default"].hoverIcon] = icon && hoverIcon,
        _a[Menu_module_scss_1["default"]["menuItem--active"]] = active,
        _a[Menu_module_scss_1["default"]["menuItem--destructive"]] = destructive,
        _a));
    if (typeof action === "string") {
        return (React.createElement("a", { href: action, className: className, "data-automation-id": automationId },
            label,
            iconNode));
    }
    return (
    // Disabling instead of addressing because this component is deprecated.
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    React.createElement("a", { href: "#", onClick: action, className: className, "data-automation-id": automationId },
        label,
        iconNode));
};
MenuItem.displayName = "MenuItem";
exports["default"] = MenuItem;
//# sourceMappingURL=MenuItem.js.map